const randColor = () => {
  return (
    "#" +
    Math.floor(Math.random() * 16777215)
      .toString(16)
      .padStart(6, "0")
      .toUpperCase()
  );
};

function UnderLine({randomColor, className, ...props}) {
  const color = randColor();
  return (
    <div
      {...props}
      style={randomColor && {
        backgroundColor: color,
        '--accent-color': color
      }}
      className={["underline", className].join(" ")}></div>
  );
}

export default UnderLine;

